export function VisitSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#5D70B5"
        d="M8 10.887a2.888 2.888 0 010-5.774 2.888 2.888 0 010 5.774zm0-4.774A1.89 1.89 0 006.113 8 1.89 1.89 0 008 9.887 1.89 1.89 0 009.887 8 1.89 1.89 0 008 6.113z"
      ></path>
      <path
        fill="#5D70B5"
        d="M8 14.013c-2.507 0-4.874-1.466-6.5-4.013-.707-1.1-.707-2.893 0-4 1.633-2.547 4-4.013 6.5-4.013S12.866 3.453 14.493 6c.707 1.1.707 2.893 0 4C12.866 12.547 10.5 14.013 8 14.013zM8 2.987c-2.154 0-4.214 1.293-5.654 3.553-.5.78-.5 2.14 0 2.92 1.44 2.26 3.5 3.553 5.654 3.553 2.153 0 4.213-1.293 5.653-3.553.5-.78.5-2.14 0-2.92-1.44-2.26-3.5-3.553-5.653-3.553z"
      ></path>
    </svg>
  );
}

export function CloseSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#FB6B7A"
        d="M9.17 15.58c-.19 0-.38-.07-.53-.22a.754.754 0 010-1.06l5.66-5.66c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L9.7 15.36c-.14.15-.34.22-.53.22z"
      ></path>
      <path
        fill="#FB6B7A"
        d="M14.83 15.58c-.19 0-.38-.07-.53-.22L8.64 9.7a.754.754 0 010-1.06c.29-.29.77-.29 1.06 0l5.66 5.66c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22z"
      ></path>
      <path
        fill="#FB6B7A"
        d="M15 22.75H9c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75zm-6-20C4.39 2.75 2.75 4.39 2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9z"
      ></path>
    </svg>
  );
}

export function BlueSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      fill="none"
      viewBox="0 0 8 8"
    >
      <path
        fill="#5D70B5"
        d="M2 7.464C-.667 5.924-.667 2.076 2 .536S8 .92 8 4c0 3.08-3.333 5.004-6 3.464z"
      ></path>
    </svg>
  );
}

export function AddIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#fff"
        d="M18 12.75H6c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h12c.41 0 .75.34.75.75s-.34.75-.75.75z"
      ></path>
      <path
        fill="#fff"
        d="M12 18.75c-.41 0-.75-.34-.75-.75V6c0-.41.34-.75.75-.75s.75.34.75.75v12c0 .41-.34.75-.75.75z"
      ></path>
    </svg>
  );
}

export function FilterIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#14345A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        d="M18.6 2.1c1.1 0 2 .9 2 2v2.2c0 .8-.5 1.8-1 2.3l-4.3 3.8c-.6.5-1 1.5-1 2.3V19c0 .6-.4 1.4-.9 1.7l-1.4.9c-1.3.8-3.1-.1-3.1-1.7v-5.3c0-.7-.4-1.6-.8-2.1l-3.8-4c-.5-.5-.9-1.4-.9-2V4.2c0-1.2.9-2.1 2-2.1h9M10.93 2.1 6 10"
      ></path>
    </svg>
  );
};
